import React from "react";
// Utils
import { useTranslation } from "gatsby-plugin-react-i18next";

export default (props) => {
  const { data } = props;
  const { t } = useTranslation();

  return (
    <section id="why" style={{ padding: "0px 0" }}>
      <div className="container" style={{ marginTop: 50, paddingBottom: 50 }}>
        <div className="row">
          <div className="col my-5 justify-content-center text-center">
            <h1 className="subheadline2">{t( data.title)}</h1>
          </div>
        </div>
        <div className="row my-4">
          {!!data.items &&
            data.items.map((item, key) => {
              const spacing = Math.floor(12 / data.items.length);
              return (
                <div key={key} className={`col-md-${spacing} px-2 text-center`}>
                  <img
                    src={item.image}
                    className="py-3"
                    style={{ maxWidth: 200 }}
                  />
                  <p
                    className="subtitle py-2 px-4"
                    style={{ color: "#5a5a54", whiteSpace: "pre-line" }}
                  >
                    {t(item.text)}
                  </p>
                </div>
              );
            })}
        </div>
        {!!data.note && (
          <div className="row py-3">
            <div className="col-md-8 mx-auto">
              <p className="smallerSubtitle mt-3" style={{ fontSize: 14 }}>
                {t(data.note)}
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
